// extracted by mini-css-extract-plugin
export default {"switzerland-view":"style_switzerland-view__028-Y","bg-map":"style_bg-map__TmwLZ"};